import { useEffect } from 'react';

import i18n from '@/config/i18n';
import { brandingConfig } from '@/config/branding';
import { TAGADAPAY_PLATFORM_NAME } from '@/lib/branding/platform-name';
import { useAppBranding } from '@/hooks/use-app-branding';
import { useRxIntegrationStatus } from '@/lib/api/rx';

const syncI18nBrandVariables = (appName: string, hubName: string) => {
  const interpolation = i18n.options.interpolation ?? {};
  i18n.options.interpolation = {
    ...interpolation,
    defaultVariables: {
      ...interpolation.defaultVariables,
      appName,
      hubName,
      platformName: TAGADAPAY_PLATFORM_NAME,
    },
  };
  i18n.emit('languageChanged');
};

/** Keeps `{{appName}}` / `{{hubName}}` in sync with runtime DB branding (Tagada fallback). */
export const useSyncI18nBranding = () => {
  const brand = useAppBranding();

  useEffect(() => {
    const appName = brand.appName || brandingConfig.appName;
    const hubName = brand.hubName ?? `${appName} Hub`;
    syncI18nBrandVariables(appName, hubName);
  }, [brand.appName, brand.hubName]);
};

/** Keeps `{{rxName}}` on the account's Rx product name ("TagadaRx", or the partner's, e.g. "KashuRx"). */
export const useSyncI18nRxName = (storeId: string) => {
  const rxName = useRxIntegrationStatus(storeId).data?.rxName;

  useEffect(() => {
    if (!rxName) return;
    const interpolation = i18n.options.interpolation ?? {};
    if (interpolation.defaultVariables?.rxName === rxName) return;
    i18n.options.interpolation = {
      ...interpolation,
      defaultVariables: { ...interpolation.defaultVariables, rxName },
    };
    i18n.emit('languageChanged');
  }, [rxName]);
};
